import * as Yup from 'yup';

export const getBulkUserCreationSchema = () => {
  const userSchema = Yup.object().shape({
    employeeId: Yup.string()
      .required('ID is required')
      .test('is-unique-employee-id', 'ID is duplicate', function (value) {
        const { userRecords } = this?.options?.context || {};
        if (!value || !userRecords) return true;
        const employeeIdCount = userRecords.filter(
          (user: any) => user.employeeId?.toLowerCase() === value.toLowerCase(),
        ).length;
        return employeeIdCount <= 1;
      }),
    fullName: Yup.string().required('Full Name is required'),
    email: Yup.string()
      .email('Invalid email format')
      .matches(/^[a-zA-Z0-9](.*[a-zA-Z0-9])?$/, 'Invalid email format')
      .required('Email is required')
      .test('is-unique-email', 'Email is duplicate', function (value) {
        const { userRecords } = this?.options?.context || {};
        if (!value || !userRecords) return true;
        const emailCount = userRecords.filter(
          (user: any) => user.email?.toLowerCase() === value.toLowerCase(),
        ).length;
        return emailCount <= 1;
      }),
    department: Yup.string().required('Department is required'),
    contactNumber: Yup.string()
      .required('Contact is required')
      .matches(/^\+?[0-9\s\-()]{7,20}$/, 'Enter valid number'),
    dateOfBirth: Yup.string().required('DOB is required'),
    dateOfHire: Yup.string()
      .required('Date of Hire is required')
      .test('is-after-dob', 'DOH after DOB', function (value) {
        const { dateOfBirth } = this.parent;
        if (!dateOfBirth || !value) return true; // skip if either is empty
        return new Date(value) > new Date(dateOfBirth);
      }),
    jobTitle: Yup.string().required('Job Title is required'),
    role: Yup.string().required('Role is required'),
    // dateOfBirth: Yup.string()
    //   .required('DOB is required')
    //   .test('is-18', 'DOB Must be 18+', function (value) {
    //     if (!value) return false;
    //     const dob = new Date(value);
    //     const today = new Date();
    //     let age = today.getFullYear() - dob.getFullYear();
    //     const m = today.getMonth() - dob.getMonth();
    //     if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
    //       age--;
    //     }
    //     return age >= 18;
    //   })
    //   .test('dob-before-dateOfHire', 'DOB before DOH', function (value) {
    //     const { dateOfHire } = this.parent;
    //     if (!value || !dateOfHire) return true;
    //     const dob = new Date(value);
    //     const hire = new Date(dateOfHire);
    //     return dob < hire;
    //   }),
    // dateOfHire: Yup.string().required('DOH is required'),
  });

  const userRecordsSchema = Yup.array().of(userSchema);

  return Yup.object().shape({
    file: Yup.array()
      .max(1, `Maximum 1 file allowed`)
      .test('file-required', 'File is required', function (value) {
        return value && value.length > 0;
      }),
    userRecords: userRecordsSchema,
  });
};
